<!--
/**
 * peacohrm is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 peacohrm Inc., http://www.peacohrm.com
 *
 * peacohrm is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * peacohrm is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="peacohrm-timeperiod-picker">
    <oxd-text tag="p" class="peacohrm-timeperiod-title">
      {{ $t('time.timesheet_period') }}
    </oxd-text>
    <oxd-icon-button
      class="peacohrm-timeperiod-icon --prev"
      name="chevron-left"
      @click="$emit('previous', $event)"
    />
    <date-input v-bind="$attrs" />
    <oxd-icon-button
      class="peacohrm-timeperiod-icon --next"
      name="chevron-right"
      @click="$emit('next', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'TimesheetPeriod',
  inheritAttrs: false,
  emits: ['previous', 'next'],
};
</script>

<style src="./timesheet-period.scss" lang="scss" scoped></style>
